import { render, staticRenderFns } from "./colorSelector.vue?vue&type=template&id=127db9fc&scoped=true&"
import script from "./colorSelector.vue?vue&type=script&lang=js&"
export * from "./colorSelector.vue?vue&type=script&lang=js&"
import style0 from "./colorSelector.vue?vue&type=style&index=0&id=127db9fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127db9fc",
  null
  
)

export default component.exports